<div class="transfer-summary d-flex flex-column justify-content-between">
    <div class="header p-4">
        <div class="d-flex justify-content-start align-items-center" (click)="backToPeertoPeer()">
            <mat-icon fontIcon="arrow_back"></mat-icon>
            <span>Back</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="icon">
                <img src="assets/p2p.svg" alt="Logo" />
            </div>
            <h2>Peer to Peer Transfer</h2>
        </div>
    </div>

    <div class="transaction-box mx-4 mb-3">
        <div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="amount-title">Amount</div>
                <button class="send-money-btn"><mat-icon class="send-money" svgIcon="send-money-v2"></mat-icon>Send money</button>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="amount-value">
                    {{ transferResponse.amount }} <span class="currency-sub-text">{{ transferResponse.currency }}</span>
                </div>
                <!-- <div class="sub-text">Ref: {{ transferResponse.transaction_id }} | {{ transferResponse.created | date : 'd MMM yyyy' }}</div> -->
                <div class="sub-text">Ref: {{ transferResponse.transaction_id }}</div>
            </div>
        </div>
        <hr />
        <div class="sub-text mb-1">
            Receiver will receive: <strong>{{ transferResponse.amount }} {{ transferResponse.currency }}</strong>
        </div>
    </div>

    <div class="summary-p2p m-4 my-2">
        <span class="my-2">Summary</span>
        <div class="summary-details my-3">
            <div class="transaction-container">
                <div class="summary-section">
                    <div class="d-flex justify-content-between align-items-center p-2">
                        <span>Transfer amount</span>
                        <span>{{ transferResponse.amount }} {{ transferResponse.currency }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center p-2">
                        <span>Exchange rate</span>
                        <span>1 {{ transferResponse.currency }} = 1 {{ transferResponse.currency }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center p-2">
                        <span>Fee</span>
                        <span>{{ transferResponse.fee_amount }}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center total-item p-2">
                        <span>Total</span>
                        <span>{{ transferResponse.amount + transferResponse.fee_amount }} {{ transferResponse.currency }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="sender-receiver-info my-3">
            <div class="header-bg-title p-2">Sender</div>
            <div class="d-flex align-items-center justify-content-between p-2 rounded">
                <div class="d-flex align-items-center">
                    <!-- <mat-icon svgIcon="user-img" class="profile-pic pe-2"></mat-icon> -->
                    <div>
                        <p class="mb-0 fw-bold sender-receiver-text">{{ userInfo.first_name + ' ' + userInfo.last_name }}</p>
                        <p class="mb-0 sender-receiver-sub-text">{{ userInfo.mobile }}</p>
                    </div>
                </div>

                <div class="d-flex align-items-center">
                    <span class="text-muted me-1">Wallet:</span>
                    <img
                        [src]="'/assets/currency-flags/' + transferResponse.currency + '-flag.svg'"
                        [alt]="transferResponse.currency"
                        style="width: 20px; height: 20px"
                        class="rounded-circle me-1"
                    />
                    <span class="fw-bold text-dark me-1">{{ transferResponse.currency }}</span>
                    <span class="text-dark">{{ '*'.repeat(7) + transferResponse?.sender_account_id?.slice(-4) }}</span>
                </div>
            </div>
        </div>

        <div class="sender-receiver-info my-3">
            <div class="header-bg-title p-2">Receiver</div>
            <div class="d-flex align-items-center justify-content-between p-2 rounded">
                <div class="d-flex align-items-center">
                    <!-- <mat-icon svgIcon="user-img" class="profile-pic pe-2"></mat-icon> -->
                    <div>
                        <p class="mb-0 fw-bold sender-receiver-text">
                            {{
                                recipientInfo.first_name[0] +
                                    '*'.repeat(recipientInfo.first_name.length - 2) +
                                    recipientInfo.first_name[recipientInfo.first_name.length - 1]
                            }}
                            {{
                                recipientInfo.last_name[0] + '*'.repeat(recipientInfo.last_name.length - 2) + recipientInfo.last_name[recipientInfo.last_name.length - 1]
                            }}
                        </p>
                        <p class="mb-0 sender-receiver-sub-text">{{ recipientInfo.mobile }}</p>
                    </div>
                </div>

                <div class="d-flex align-items-center">
                    <span class="text-muted me-1">Wallet:</span>
                    <img
                        [src]="'/assets/currency-flags/' + transferResponse.currency + '-flag.svg'"
                        [alt]="transferResponse.currency"
                        style="width: 20px; height: 20px"
                        class="rounded-circle me-1"
                    />
                    <span class="fw-bold text-dark me-1">{{ transferResponse.currency }}</span>
                    <span class="text-dark">{{ '*'.repeat(7) + transferResponse.recipient_account_id.slice(-4) }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-start align-items-center p-4">
        <button mat-raised-button class="btn-primary rounded-pill me-2" [class.button-spinner]="loading" [disabled]="loading" (click)="confirmTransfer()">
            {{ loading ? '' : 'Confirm Transfer' }}
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="backToPeertoPeer()">Cancel</button>
    </div>
</div>
